module.exports = __webpack_public_path__ + "img/Parking.c5677dad.jpg";